var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[_c('div',{staticClass:"top"},[_vm._t("default"),_c('i')],2),_c('img',{attrs:{"src":require("../assets/icons/information.svg"),"alt":"info"}})])}
var staticRenderFns = []

export { render, staticRenderFns }